/**
 * Layout Services.
 * @format
 */

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    drupalSettings: any;
  }
}
/**
 * Load Layout Services.
 */
export const loadLayoutServices = (): void => {
  /**
   * Courses Scripts.
   */
  const initializeCoursesScripts = () => {
    /**
     * Setup Dates Toggle.
     */
    const setupDatesToggle = () => {
      const toggleButtons: NodeListOf<HTMLElement> =
        document.querySelectorAll('.dates-toggle');
      if (toggleButtons.length > 0) {
        toggleButtons.forEach((dateToggle: HTMLElement) => {
          dateToggle.addEventListener('click', () => {
            const courseId: string | undefined = dateToggle.dataset.course;
            if (courseId) {
              const allDates = document.getElementById(courseId);
              if (allDates) {
                allDates.classList.toggle('show-dates');
              }
            }
            dateToggle.classList.toggle('show-less');
          });
        });
      }
    };

    const coursesPage: HTMLElement | null = document.querySelector(
      '.courses-training-page-type'
    );
    if (coursesPage) {
      setupDatesToggle();
    }
  };
  initializeCoursesScripts();

  /**
   * Breadcrumb Check.
   */
  const breadcrumbCheck = () => {
    const bodyClassList = document.body.classList;
    const noBreadcrumbPages = [
      'path-frontpage',
      'page-node-type-treatment-location',
      'page-node-type-course',
      'page-node-type-event',
      'page-node-type-cme-credit',
    ];
    if (
      noBreadcrumbPages.some((className) => bodyClassList.contains(className))
    ) {
      const header: HTMLElement | null = document.getElementById('nav-header');
      if (header) {
        header.classList.add('no-breadcrumb');
      }
    }
  };
  breadcrumbCheck();
};
